import graphqlClientFactory from 'lib/graphql-client-factory';
import ArticleCategoryTabsQuery from 'components/authorable/shared/page-specific/ArticleCategoryTabs.graphql';
import ArticleContentClient from './ArticleContentClient';
export default ArticleContentClient;
